// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  body: JSX.Element;
  ok: string;
  okCallback: (event: React.MouseEvent) => void;
  open: boolean;
}

const Dialog: React.FC<Props> = ({ label, body, ok, okCallback, open }) => {
  const handleClickOk = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    okCallback(event);
  }, []);

  return (
    <div className="dialog">
      <div className="dialog-mask" style={{ display: open ? 'block' : 'none' }}></div>
      <div className="dialog-section" style={{ display: open ? 'block' : 'none' }}>
        <div className="dialog-inner">
          <div className="dialog-contents">
            <h3>{label}</h3>
            <div className="dialog-body">{body}</div>
            <Row className="dialog-button">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <button
                  className="c-btn btn-large btn-main-color mx-auto"
                  type="button"
                  onClick={handleClickOk}
                >
                  {ok}
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
